// extracted by mini-css-extract-plugin
export default {"input_box":"TextArea_input_box__-vH3D","half":"TextArea_half__CO+sb","icon":"TextArea_icon__2UeUz"};